/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MobileAgentsResponse } from '../models/MobileAgentsResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MobileAgentsService {
    /**
     * List the mobile user's governed AI agents
     * @param pageSize
     * @param pageToken
     * @param xMobileAuth
     * @returns MobileAgentsResponse Successful Response
     * @throws ApiError
     */
    public static listMyAgents(
        pageSize: number = 50,
        pageToken: string = '',
        xMobileAuth?: (string | null),
    ): CancelablePromise<MobileAgentsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/mobile/v1/agents',
            headers: {
                'X-Mobile-Auth': xMobileAuth,
            },
            query: {
                'page_size': pageSize,
                'page_token': pageToken,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
